import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

export const useRedirectToLinkAccount = () => {
  const shouldNavigateToLinkAccount = useSelector((state: any) => state.app.redirectToLinkAccount);
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldNavigateToLinkAccount) {
      navigate('/link-account');
    }
  }, [shouldNavigateToLinkAccount]);
};
